<template>
	<div ref="emblaRef" class="carousel image-slider columns column6">
		<div class="carousel-container">
			<div v-for="(image, index) in images" :key="index" class="slide-content">
				<picture>
					<source :srcset="image.imageWebp" type="image/webp" />
					<source :srcset="image" />
					<img :src="image" :alt="image.imageAlt" />
				</picture>
			</div>
		</div>

		<div v-if="images?.length > 1" class="embla-controls">
			<div class="button-prev" @click="prevSlide">
				<font-awesome-icon icon="fal fa-chevron-left" size="1x" />
			</div>
			<div class="button-next" @click="nextSlide">
				<font-awesome-icon icon="fal fa-chevron-right" size="1x" />
			</div>
		</div>
	</div>
</template>

<script setup>
import emblaCarouselVue from 'embla-carousel-vue';
import Autoplay from 'embla-carousel-autoplay';

defineProps({
	images: { type: Array, default: () => [] },
});

const [emblaRef, emblaApi] = emblaCarouselVue({ loop: true, duration: 30 }, [
	Autoplay({ delay: 5500, stopOnInteraction: false }),
]);

const selectedScrollSnap = ref(0);

function prevSlide() {
	emblaApi.value?.scrollPrev();
}

function nextSlide() {
	emblaApi.value?.scrollNext();
}

onMounted(() => {
	if (!emblaApi.value) {
		return;
	}

	emblaApi.value.on('select', () => {
		if (!emblaApi.value) {
			return;
		}

		selectedScrollSnap.value = emblaApi.value.selectedScrollSnap();
	});
});
</script>

<style lang="scss" scoped>
.image-slider {
	overflow: hidden;
	max-width: 600px;
	width: 100%;

	img {
		width: 100%;
		position: relative;
		z-index: 1;
	}
}

.slide-content {
	flex: 0 0 100%;
	user-select: none;
}

.carousel-container {
	display: flex;
}

.embla-controls {
	display: flex;
	justify-content: space-between;
	position: absolute;
	top: auto;
	right: 20px;
	bottom: calc(50% - 9px);
	left: 20px;
	z-index: 10;

	button {
		width: 14px;
		height: 14px;
		border-radius: 50%;
		background-color: #cbcbcb9e;
		margin: 0 5px;
		cursor: pointer;
		border: none;
		box-shadow: none;

		&.active {
			background-color: #fff;
		}
	}
}
</style>
